import { useState } from "react"
import { message } from "antd"
import { ApiPlacementListByCampaignLogHistory } from "../../../api-wrapper/advertising/ApiAdvertising"
import { ApireverseBidChange } from "../../../api-wrapper/campaign/ApiCampaignName"
import { usePagedHistory, IHistoryPageQuery } from "../hooks/usePagedHistory"
import { useTypedSelector } from "../../../hooks/useTypedSelector"

import useSkcHistoryColumns from "../hooks/useSkcHistoryColumns"
import { ISkcHistoryRecord } from "../types/history.types"
import HistoryToolbar from "./HistoryToolbar"
import HistoryStatusSelect from "./HistoryStatusSelect"
import HistoryTable from "./HistoryTable"

const SkcHistory: React.FC = () => {
  const [status, setStatus] = useState("")
  const columns = useSkcHistoryColumns()

  const fetchPage = (query: IHistoryPageQuery) =>
    ApiPlacementListByCampaignLogHistory({ ...query, status })

  const { rows, totalRecords, loading, pageNo, perPage, changePage, reload } =
    usePagedHistory<ISkcHistoryRecord>(fetchPage, [status])
  const { dateRange } = useTypedSelector((state) => state.filter)

  const reverseChanges = async () => {
    if (!rows.length) {
      message.error("No campaigns to reverse")
      return
    }

    try {
      const response = await ApireverseBidChange({
        profileId: localStorage.getItem("profileId") || "",
        from: dateRange.from,
        to: dateRange.to,
        timezone: localStorage.getItem("antonTimezone"),
      })
      message.success(response?.message ?? "Changes reversed")
      reload()
    } catch (e: any) {
      message.error(e?.response?.data?.message ?? "Something went wrong")
    }
  }

  return (
    <>
      <HistoryToolbar onReverse={reverseChanges}>
        <HistoryStatusSelect value={status} onChange={setStatus} />
      </HistoryToolbar>

      <HistoryTable
        columns={columns}
        rows={rows}
        loading={loading}
        pageNo={pageNo}
        perPage={perPage}
        totalRecords={totalRecords}
        onPageChange={changePage}
      />
    </>
  )
}

export default SkcHistory
